export enum InstagramMediaType {
  REELS = 'REELS',
  STORIES = 'STORIES',
}

export enum InstagramCollaboratorType {
  NONE = 'NONE',
  INVITE_COLLABORATOR = 'INVITE_COLLABORATOR',
}

export interface InstagramMetadata {
  // Account capabilities
  mediaTypes: InstagramMediaType[];
  maxVideoDurationSeconds: number;

  // Default publishing settings
  shareToFeed: boolean;
  coverImageTimestamp?: number; // Timestamp in ms for cover image

  // Collaborators
  collaborators: string[]; // Instagram usernames
}

export const instagramDefaultMetadata: InstagramMetadata = {
  mediaTypes: [InstagramMediaType.REELS],
  maxVideoDurationSeconds: 90, // Instagram Reels max duration
  shareToFeed: true,
  collaborators: [],
};
